import { parseNDJSONSync } from "./lib/parsers/parse-ndjson.js";
import { parseNDJSONInBatches } from "./lib/parsers/parse-ndjson-in-batches.js";
const VERSION = typeof "4.1.0-alpha.9" !== 'undefined' ? "4.1.0-alpha.9" : 'latest';
export const NDJSONLoader = {
  name: 'NDJSON',
  id: 'ndjson',
  module: 'json',
  version: VERSION,
  extensions: ['ndjson', 'jsonl'],
  mimeTypes: ['application/x-ndjson', 'application/jsonlines', 'application/json-seq'],
  category: 'table',
  text: true,
  parse: async arrayBuffer => parseNDJSONSync(new TextDecoder().decode(arrayBuffer)),
  parseTextSync: parseNDJSONSync,
  parseInBatches: parseNDJSONInBatches,
  options: {}
};
//# sourceMappingURL=ndjson-loader.js.map